import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { EncryptionConfiguration } from '@ragu-components/ord-types';

const EncryptionConfigurationsList = React.lazy(async () => import('./EncryptionConfigurationsList'));

export const encryptionConfigurationsResource: OrdResourceProps = {
  key: Resources.encryption_configurations,
  name: Resources.encryption_configurations,
  list: <EncryptionConfigurationsList />,
  options: {},
  recordRepresentation: (record: EncryptionConfiguration): string => record.name,
};
